import { Link } from "react-router-dom";
import { ArrowUpRight, Dribbble, Footprints, Goal, Volleyball, Waves, Trophy } from "lucide-react";

const SPORTS = [
  { icon: Goal, t: "Fútbol", d: "Equipaciones, balones y material técnico.", to: "/tienda?q=futbol" },
  { icon: Dribbble, t: "Baloncesto", d: "Ropa y accesorios para la cancha.", to: "/tienda?q=baloncesto" },
  { icon: Volleyball, t: "Tenis y pádel", d: "Raquetas y complementos deportivos.", to: "/tienda?q=padel" },
  { icon: Footprints, t: "Running", d: "Calzado y ropa para salir a correr.", to: "/tienda?q=running" },
  { icon: Waves, t: "Natación", d: "Material para el entrenamiento en el agua.", to: "/tienda?q=natacion" },
  { icon: Trophy, t: "Calzado deportivo", d: "Modelos para distintas edades y tallas.", to: "/tienda?category=calzado" },
];

export const SportsGrid = () => (
  <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 mt-24" data-testid="home-sports">
    <p className="eyebrow">Encuentra tu deporte</p>
    <h2 className="mt-2 font-heading text-3xl lg:text-5xl font-black uppercase tracking-tight">Equípate para lo que <span className="text-verde">te mueve.</span></h2>
    <div className="mt-10 grid grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border">
      {SPORTS.map(({ icon: I, t, d, to }) => (
        <Link key={t} to={to} className="group bg-white p-5 sm:p-8 flex flex-col gap-3 hover:bg-slate-50 transition-colors" data-testid={`sport-${t.split(" ")[0].toLowerCase()}`}>
          <span className="w-11 h-11 rounded-full bg-brand/10 text-brand grid place-items-center group-hover:bg-brand group-hover:text-white transition-colors"><I className="w-5 h-5" /></span>
          <span className="flex items-center justify-between font-heading text-lg sm:text-2xl font-black uppercase tracking-tight">{t}<ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" /></span>
          <span className="text-xs sm:text-sm text-slate-500">{d}</span>
        </Link>
      ))}
    </div>
  </section>
);

export const OutletBanner = () => (
  <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 mt-16">
    <Link to="/outlet" className="group grid lg:grid-cols-2 overflow-hidden border bg-[#FBFBF8]" data-testid="home-outlet-banner">
      <div className="p-8 lg:p-12 flex flex-col justify-center">
        <p className="eyebrow">Sobrino Sport · Outlet online</p>
        <p className="mt-3 font-heading text-4xl lg:text-5xl font-black uppercase tracking-tight leading-none">Las ofertas de la tienda, <span className="text-verde">también online.</span></p>
        <p className="mt-4 text-slate-600 text-sm max-w-md">Modelos de temporadas anteriores con grandes descuentos. Busca tu talla y cómpralo con Bizum o transferencia.</p>
        <span className="mt-6 btn-primary btn-verde self-start">Explorar outlet <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" /></span>
      </div>
      <img src="/aim-objetos.jpg" alt="Zapatilla, balón, pesa y botella" loading="lazy" className="w-full h-full object-cover min-h-[220px]" />
    </Link>
  </section>
);
